.button {
    position: relative;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    align-self: flex-start;
    border: 1px solid var(--colorBorderPrimary);
    border-radius: 32px;
    background-color: var(--colorButtonSecondary);
    cursor: pointer;
    outline: none;
}

.small {
    height: 32px;
    padding: 0 12px;
}

.large {
    height: 40px;
    padding: 0 20px;
}

/* The visible content row — its own flex container so the spinner can be absolutely
   centered over it without disturbing the emoji/label/icon layout. */
.content {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
}

.small .content {
    gap: 6px;
}

.large .content {
    gap: 12px;
}

/* Selected drops the border. Small selected is a subtle light surface; large selected is
   the strong near-black primary fill with white content (see the component for text color). */
.button[data-selected] {
    border-color: transparent;
}

.small[data-selected] {
    background-color: var(--colorSurfaceSecondary);
}

.large[data-selected] {
    background-color: var(--colorButtonPrimary);
}

/* Hover/press overlays, per Figma. Light backgrounds (unselected, or small-selected) darken;
   the dark large-selected fill lightens. color-mix reproduces the Figma rgba overlays exactly
   (e.g. black 10% over white = #e6e6e6). Selected rules are more specific, so they win. */
.button[data-hovered] {
    background-color: color-mix(in srgb, black 10%, var(--colorButtonSecondary));
}

.button[data-pressed] {
    background-color: color-mix(in srgb, black 20%, var(--colorButtonSecondary));
}

.small[data-selected][data-hovered] {
    background-color: color-mix(in srgb, black 10%, var(--colorSurfaceSecondary));
}

.small[data-selected][data-pressed] {
    background-color: color-mix(in srgb, black 20%, var(--colorSurfaceSecondary));
}

.large[data-selected][data-hovered] {
    background-color: color-mix(in srgb, white 20%, var(--colorButtonPrimary));
}

.large[data-selected][data-pressed] {
    background-color: color-mix(in srgb, white 40%, var(--colorButtonPrimary));
}

.button[data-focus-visible] {
    outline: 1px solid var(--colorBorderAccent);
    outline-offset: 2px;
}

/* Genuine disabled only — NOT loading. Loading keeps its normal (white/dark) fill and shows the
   spinner; both set RAC's data-disabled to block presses, so loading is excluded via :not(.loading).
   Text/icon disabled color is applied in the component. */
.button[data-disabled]:not(.loading) {
    background-color: var(--colorButtonDisabled);
    border-color: var(--colorButtonDisabled);
}

.button[data-disabled] {
    cursor: default;
}

/* Hide the content without removing it from layout, so the button keeps its width when the
   spinner replaces the label. */
.invisible {
    visibility: hidden;
}

/* Center the spinner over the (visibility-hidden) content. */
.spinnerWrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 0;
}
